"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimezoneAbbreviation = exports.TimezoneDisplayNameWithIdentifier = exports.TimezoneDisplayName = exports.TimezoneName = void 0;
// Values in TimezoneName enum need to be values supported by
// Postgres. If you need to add a new timezone, make sure to check
// that the name you are using is supported by Postgres.
var TimezoneName;
(function (TimezoneName) {
    TimezoneName["US_EAST"] = "America/New_York";
    TimezoneName["US_CENTRAL"] = "America/Chicago";
    TimezoneName["US_MOUNTAIN"] = "America/Denver";
    TimezoneName["US_PACIFIC"] = "America/Los_Angeles";
    TimezoneName["US_ALASKA"] = "America/Anchorage";
    TimezoneName["US_HAWAII"] = "Pacific/Honolulu";
    TimezoneName["US_HAWAII_ALEUTIAN"] = "America/Adak";
    TimezoneName["US_ARIZONA"] = "America/Phoenix";
    TimezoneName["US_PUERTO_RICO"] = "America/Puerto_Rico";
    TimezoneName["US_ATLANTIC"] = "Atlantic/Bermuda";
    TimezoneName["US_ST_JOHNS"] = "America/St_Johns";
})(TimezoneName = exports.TimezoneName || (exports.TimezoneName = {}));
var TimezoneDisplayName;
(function (TimezoneDisplayName) {
    TimezoneDisplayName["US_EAST"] = "Eastern Time";
    TimezoneDisplayName["US_CENTRAL"] = "Central Time";
    TimezoneDisplayName["US_MOUNTAIN"] = "Mountain Time";
    TimezoneDisplayName["US_PACIFIC"] = "Pacific Time";
    TimezoneDisplayName["US_ALASKA"] = "Alaska Time";
    TimezoneDisplayName["US_HAWAII"] = "Hawaii Time";
    TimezoneDisplayName["US_HAWAII_ALEUTIAN"] = "Hawaii-Aleutian Time";
    TimezoneDisplayName["US_ARIZONA"] = "Mountain Standard Time";
    TimezoneDisplayName["US_PUERTO_RICO"] = "Atlantic Standard Time";
    TimezoneDisplayName["US_ATLANTIC"] = "Atlantic Time";
    TimezoneDisplayName["US_ST_JOHNS"] = "Newfoundland Standard Time";
})(TimezoneDisplayName = exports.TimezoneDisplayName || (exports.TimezoneDisplayName = {}));
var TimezoneDisplayNameWithIdentifier;
(function (TimezoneDisplayNameWithIdentifier) {
    TimezoneDisplayNameWithIdentifier["US_EAST"] = "Eastern Time (America/New York)";
    TimezoneDisplayNameWithIdentifier["US_CENTRAL"] = "Central Time (America/Chicago)";
    TimezoneDisplayNameWithIdentifier["US_MOUNTAIN"] = "Mountain Time (America/Denver)";
    TimezoneDisplayNameWithIdentifier["US_PACIFIC"] = "Pacific Time (America/Los Angeles)";
    TimezoneDisplayNameWithIdentifier["US_ALASKA"] = "Alaska Time (America/Anchorage)";
    TimezoneDisplayNameWithIdentifier["US_HAWAII"] = "Hawaii Time (Pacific/Honolulu)";
    TimezoneDisplayNameWithIdentifier["US_HAWAII_ALEUTIAN"] = "Hawaii-Aleutian Time (America/Adak)";
    TimezoneDisplayNameWithIdentifier["US_ARIZONA"] = "Mountain Standard Time (America/Phoenix)";
    TimezoneDisplayNameWithIdentifier["US_PUERTO_RICO"] = "Atlantic Standard Time (America/Puerto Rico)";
    TimezoneDisplayNameWithIdentifier["US_ATLANTIC"] = "Atlantic Time (America/Atlantic)";
    TimezoneDisplayNameWithIdentifier["US_ST_JOHNS"] = "Newfoundland Standard Time (America/St Johns)";
})(TimezoneDisplayNameWithIdentifier = exports.TimezoneDisplayNameWithIdentifier || (exports.TimezoneDisplayNameWithIdentifier = {}));
var TimezoneAbbreviation;
(function (TimezoneAbbreviation) {
    TimezoneAbbreviation["US_EAST"] = "ET";
    TimezoneAbbreviation["US_CENTRAL"] = "CT";
    TimezoneAbbreviation["US_MOUNTAIN"] = "MT";
    TimezoneAbbreviation["US_PACIFIC"] = "PT";
    TimezoneAbbreviation["US_ALASKA"] = "AKT";
    TimezoneAbbreviation["US_HAWAII"] = "HST";
    TimezoneAbbreviation["US_HAWAII_ALEUTIAN"] = "HT";
    TimezoneAbbreviation["US_ARIZONA"] = "MST";
    TimezoneAbbreviation["US_PUERTO_RICO"] = "AST";
    TimezoneAbbreviation["US_ATLANTIC"] = "AT";
    TimezoneAbbreviation["US_ST_JOHNS"] = "NT";
})(TimezoneAbbreviation = exports.TimezoneAbbreviation || (exports.TimezoneAbbreviation = {}));
//# sourceMappingURL=Timezones.js.map